import React from 'react';
import { Card, CardContent } from './ui/card';
import { Wallet, FileText, ShoppingCart, Sparkles } from 'lucide-react';

export const AgentsSection = () => {
  const agents = [
    {
      id: 'lucas',
      name: 'Lucas',
      subtitle: 'Finanzas',
      description: 'Lleva el control de tus lucas y gastos escribiendo por el chat como si fuera un pana.',
      icon: Wallet,
      available: true,
      color: '#25D366',
    },
    {
      id: 'simon',
      name: 'Simón',
      subtitle: 'Legal',
      description: 'Próximamente.',
      icon: FileText,
      available: false,
      color: '#3B82F6',
    },
    {
      id: 'tere',
      name: 'Tere',
      subtitle: 'Ventas',
      description: 'Próximamente.',
      icon: ShoppingCart,
      available: false,
      color: '#8B5CF6',
    },
  ];

  return (
    <section id="agentes" className="py-24 bg-[#0F172A] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #25D366 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-[#25D366]/10 px-4 py-2 rounded-full border border-[#25D366]/20">
            <Sparkles className="h-4 w-4 text-[#25D366]" />
            <span className="text-[#25D366] text-sm font-medium">El Combo</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white">
            Conoce al Combo
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Cada agente está especializado para resolver tus necesidades específicas
          </p>
        </div>

        {/* Agents Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {agents.map((agent, index) => {
            const Icon = agent.icon;
            return (
              <div 
                key={agent.id}
                className="animate-fade-in-up"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <Card 
                  className={`
                    relative overflow-hidden bg-white/5 border-white/10 backdrop-blur-sm
                    transition-all duration-300 hover:bg-white/10 hover:border-white/20
                    hover:transform hover:scale-105 hover:shadow-2xl
                    ${agent.available ? 'hover:border-[#25D366]/50' : ''}
                  `}
                >
                  {/* Available Badge */}
                  {agent.available && (
                    <div className="absolute top-4 right-4 z-10">
                      <div className="bg-[#25D366] text-white text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1">
                        <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                        Activo
                      </div>
                    </div>
                  )}

                  {/* Not Available Overlay */}
                  {!agent.available && (
                    <div className="absolute inset-0 bg-[#0F172A]/60 backdrop-blur-sm z-10 flex items-center justify-center">
                      <div className="bg-white/10 backdrop-blur-md px-6 py-3 rounded-lg border border-white/20">
                        <span className="text-white font-semibold">Próximamente</span>
                      </div>
                    </div>
                  )}

                  <CardContent className="p-8 space-y-6">
                    {/* Icon */}
                    <div 
                      className="w-16 h-16 rounded-2xl flex items-center justify-center transition-transform duration-300 hover:rotate-6"
                      style={{ 
                        backgroundColor: `${agent.color}20`,
                        border: `2px solid ${agent.color}40`
                      }}
                    >
                      <Icon 
                        className="h-8 w-8" 
                        style={{ color: agent.color }}
                      />
                    </div>

                    {/* Content */}
                    <div className="space-y-2">
                      <h3 className="text-2xl font-bold text-white">
                        {agent.name}
                      </h3>
                      <div 
                        className="text-sm font-medium"
                        style={{ color: agent.color }}
                      >
                        {agent.subtitle}
                      </div>
                      <p className="text-white/60 leading-relaxed">
                        {agent.description}
                      </p>
                    </div>

                    {/* Action */}
                    {agent.available && (
                      <button 
                        onClick={() => window.open('https://wa.me/584225997721', '_blank')}
                        className="w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#25D366]/20"
                      >
                        Probar ahora
                      </button>
                    )}
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
